import { Component, OnInit } from '@angular/core';
import {SubscribedComponent} from "../subscribed.component";
import {FormBuilder, FormControl} from "@angular/forms";
import {NbLayoutScrollService} from "@nebular/theme";
import {Router} from "@angular/router";
import {ShowableFormGroup} from "../shared/ShowableFormGroup";
import {BSValidators} from "../shared/bsvalidators";
import {Globals} from "../shared/Globals";
import {stickyColumns, columns} from "./coldefs-client";
import {ClientService} from "../shared/client.service";
import {Client} from "../interfaces/client";

@Component({
    selector: 'bst-new-client',
    templateUrl: './new-client.component.html',
    styleUrls: ['../project/projects.component.scss', './clients.component.scss'],
    standalone: false
})
export class NewClientComponent extends SubscribedComponent{

  public forms: ShowableFormGroup[] = [];
  columns = columns;
  headers = stickyColumns;

  constructor(private fb: FormBuilder,
              public scroll: NbLayoutScrollService,
              private clientService: ClientService,
              private router: Router) {
    super();
  }


  ngOnInit(): void {
    super.ngOnInit();
    this.bootstrap();
  }

  private async bootstrap(){
    this.forms = [];
    for(let c of this.columns.concat(this.headers)){
      if(c.group){
        const index = c.group-1;
        if(!this.forms[index]){
          this.forms[index] = new ShowableFormGroup(this.fb.group({}));
        }

        const validators = c.validators || [];
        this.forms[index].form.addControl(c.name, new FormControl({value: null, disabled: (c.disabled || false)}, validators));
        if(c.name === 'phone'){
          this.subs.push(BSValidators.armPhoneValidator(this.forms[index].form.get('phone')));
        }
      }
    }
  }

  private get values(): Client{
    let newclient:any = {};
    this.forms.forEach((o) => {
      newclient = {...newclient, ...o.form.value};
    });
    if (newclient.phone && (<any>newclient.phone).e164Number) {
      newclient.phone = (<any>newclient.phone).e164Number;
    }
    return newclient;
  }

  async submit() {
    if(!this.loading.getValue()){
      this.loading.next(true);
      const client = await this.clientService.addClient(this.values);
      if(client && client.id){
        await this.router.navigate(['clients/' + client.id]);
      }
      this.loading.next(false);
    }
  }
}
